import React, { useContext, useEffect, useState } from "react"
import { InputText } from "../../../../components/inputText/InputText"
import { AvatarBlock } from "../addClient/AvatarBlock"
import { CloseButton, PopupButton, PopupWrapper } from "../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "./SideMenuCommon";
import "./SideMenuProfile.css";
import { AppContext } from "../../../../appContext";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";
import { uploadAvatar } from "../../../../api/api";
import { getAvatarList, getAvatarByKey } from "../../../../utils/avatars";
import { Spinner } from "../../../../components/spinner/Spinner";

export const SideMenuProfile = ({onClose}: ISideMenuRouteProps) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [avatar, setAvatar] = useState<HTMLCanvasElement>(null);
    const [errors, setErrors] = useState<any>({});
    const [isRequestSent, setIsRequestSent] = useState(false);
    const [result, setResult] = useState('');
    const {translate, saveUserSettings, userSettings} = useContext(AppContext);
    
    useEffect(()=>{
        if (!userSettings){
            return;
        }
        setFirstName(userSettings.firstName);
        setLastName(userSettings.lastName);
    }, [userSettings]);
    
    const handleSave = ()=>{
        setIsRequestSent(true);
        if (avatar){
            avatar.toBlob((blob)=>{
                uploadAvatar(blob, ()=>{}).then(res=>{
                    console.log('avatar result: ', res);
                    return saveUserSettings({
                        firstName,
                        lastName,
                        customAvatarUrl: res.url
                    })
                }).then(()=>{
                    setResult('success');
                }).catch(()=>{
                    setResult('error');
                }).finally(()=>{
                    setIsRequestSent(false);
                })
            }, "image/png");
        } else {
            saveUserSettings({
                firstName,
                lastName,
                customAvatarUrl: userSettings.customAvatarUrl
            }).then(()=>{
                setResult('success');
            }).catch(()=>{
                setResult('error');
            }).finally(()=>{
                setIsRequestSent(false);
            })
        }
    }

    const handleClose = ()=>{
        onClose();
    }

    return <PopupWrapper className="SideMenuProfile">
        <SideMenuCommonHeader text={translate('sideMenu_profile')} onClose={handleClose}></SideMenuCommonHeader>
        <div className="SideMenuProfile_form">
            <AvatarBlock onImageUpdate={(avatar) => setAvatar(avatar)} initialAvatarUrl={userSettings?.customAvatarUrl}></AvatarBlock>
            <InputText 
                className="addClient_firstName" 
                label={translate('common_firstName')} 
                value={firstName} 
                onChange={(e)=>{setFirstName(e)}}
                error={errors.firstName}
            ></InputText>
            <InputText 
                className="addClient_lastName" 
                label={translate('common_lastName')} 
                value={lastName} 
                onChange={(e)=>{setLastName(e)}}
                error={errors.lastName}
            ></InputText>
        </div>
        <div className="SideMenuProfile_buttons">
            {result == 'success' && <div>User profile updated</div>}
            {result == 'error' && <div>Error</div>}
            <PopupButton onClick={handleSave}>{isRequestSent ? <Spinner></Spinner> : translate('common_save')}</PopupButton>
        </div>
    </PopupWrapper>
}